import { apiRequest } from './api.js';
import { getSession } from './auth.js';

export const STORAGE_KEY = 'painel-trafego:data-v1';

export const store = {
  async get(key){
    if(key === STORAGE_KEY){
      if(getSession()){
        try{
          const res = await apiRequest('/panel/state');
          if(res?.data) return JSON.stringify(res.data);
          return null;
        }catch(err){
          console.warn('Painel remoto indisponível, usando dados locais.', err);
        }
      }
    }
    if(window.storage && typeof window.storage.get === 'function'){
      const res = await window.storage.get(key, false);
      return res && res.value ? res.value : null;
    }
    return localStorage.getItem(key);
  },
  async set(key, value){
    let remoteError = null;
    if(key === STORAGE_KEY){
      if(getSession()){
        try{
          const state = typeof value === 'string' ? JSON.parse(value) : value;
          await apiRequest('/panel/state', {
            method: 'PUT',
            body: JSON.stringify({ state }),
          });
        }catch(err){
          remoteError = err;
        }
      }
    }
    if(window.storage && typeof window.storage.set === 'function'){
      await window.storage.set(key, value, false);
    } else {
      localStorage.setItem(key, value);
    }
    if(remoteError) throw remoteError;
  }
};
